const formatString = (dato, len) => {
    dato = (dato) ? dato : " ";
    const complemento = ' '.repeat(len);
    let cadena = dato.replace(/\n/g, '');
    cadena = cadena.replace(/\r/g, '');
    cadena = cadena.toString() + complemento;
    cadena = cadena.substr(0, len);
    return cadena;
}

const formatNumber = (dato, len) => {
    dato = (dato) ? dato : "0";
    const complemento = '0'.repeat(len);
    let cadena = complemento + dato.toString();
    cadena = cadena.substr(len * (-1));
    return cadena;
}

const formatPrice = (value) => {
    if (!value || value === '0000000000000') return 0;
    const num = parseInt(value, 10);
    const parteEntera = num / 10000.00;
    return parteEntera;
};

const removeDecimals = (value) => {
    if (!value) return '0000000000000';
    const cleanValue = value.toString().replace(',', '.');
    const num = parseFloat(cleanValue);
    if (isNaN(num)) return '0000000000000';
    const parteEntera = Math.floor(num);
    const parteDecimal = Math.round((num - parteEntera) * 10000);
    const resultado = parteEntera * 10000 + parteDecimal;
    return resultado.toString().padStart(13, '0');
};

const formatDate = (value) => {
    if (!value || value === '00000000') return '';
    const year = value.substring(0, 4);
    const month = value.substring(4, 6);
    const day = value.substring(6, 8);
    return `${year}-${month}-${day}`;
};

const formatDateToNumber = (dateStr) => {
    if (!dateStr || dateStr.trim() === '') return '00000000';
    
    const cleaned = dateStr.trim();
    let day, month, year;

    if (cleaned.includes('/')) {
        const parts = cleaned.split('/');
        if (parts.length === 3) {
            day = parts[0].padStart(2, '0');
            month = parts[1].padStart(2, '0');
            year = parts[2];
            if (year.length === 2) {
                year = (parseInt(year, 10) > 50) ? '19' + year : '20' + year;
            }
        } else {
            return '00000000';
        }
    } else if (cleaned.includes('-')) {
        const parts = cleaned.split('-');
        if (parts.length === 3) {
            year = parts[0];
            month = parts[1].padStart(2, '0');
            day = parts[2].padStart(2, '0');
        } else {
            return '00000000';
        }
    } else if (cleaned.length === 8 && !isNaN(cleaned)) {
        year = cleaned.substring(0, 4);
        month = cleaned.substring(4, 6);
        day = cleaned.substring(6, 8);
    } else {
        return '00000000';
    }

    if (!year || !month || !day || year.length < 4) return '00000000';

    return year + month + day;
};

const processCabeceraPrecios = () => {
    const tmpData = [
        // "MODO CÓDIGO",
        // "CÓDIGO BARRAS",
        "CODIGO ITEM",
        // "EXTENSIÓN",
        "PRECIO UNITARIO",
        "UNIDAD MEDIDA",
        // "DESCRIPCIÓN",
        // "PRECIO SUGERIDO",
        // "PRECIO MÁXIMO",
        // "IMPOCONSUMO 1",
        // "IMPOCONSUMO 2",
        "CODIGO LISTA",
        "FECHA VIGENCIA"
    ]
    return tmpData;
}

const processLinePrecios = (linea) => {
    const tmpData = [
        // linea.substring(0, 1),
        // linea.substring(1, 16).trim(),
        linea.substring(16, 22).trim(),
        // linea.substring(22, 25).trim(),
        formatPrice(linea.substring(25, 38)),
        linea.substring(38, 41).trim(),
        // linea.substring(41, 81).trim(),
        // formatPrice(linea.substring(81, 94)),
        // formatPrice(linea.substring(94, 107)),
        // formatPrice(linea.substring(107, 120)),
        // formatPrice(linea.substring(120, 133)),
        linea.substring(133, 136).trim(),
        formatDate(linea.substring(136, 144))
    ];
    return tmpData;
};

const processFormatCadenaPrecios = (data) => {
    let linea = "";
    
    const modoCodigo = 'I' //(data[0] === 'I' || data[0] === 'R' || data[0] === 'B' || data[0] === 'D') ? data[0] : ' ';
    const codBarras = formatString(" ", 15);
    const codItem = formatNumber(data[0], 6);
    const extension = formatString(" ", 3);
    const precio = formatNumber(removeDecimals(data[1]), 13);
    const uniMed = formatString(data[2], 3);
    const descripcion = formatString(" ", 40);
    const precioSugerido = formatNumber(0, 13);
    const precioMax = formatNumber(0, 13);
    const impoconsumo1 = formatNumber(0, 13);
    const impoconsumo2 = formatNumber(0, 13);
    const codLista = formatNumber(data[3], 3);
    const fechaVig = formatDateToNumber(data[4]);

    linea = modoCodigo + codBarras + codItem + extension + precio + uniMed + 
            descripcion + precioSugerido + precioMax + impoconsumo1 + 
            impoconsumo2 + codLista + fechaVig;
    
    linea += "\n";
    return linea;
};

const funciones = {
    processCabeceraPrecios: processCabeceraPrecios,
    processLinePrecios: processLinePrecios,
    processFormatCadenaPrecios: processFormatCadenaPrecios,
    formatPrice: formatPrice,
    formatDate: formatDate,
    formatString: formatString,
    formatNumber: formatNumber
}

export default funciones;



// WEBPACK FOOTER //
// ./src/middleware/extractInfoPrecios.js